// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"733a924e","396":"2e390497","667":"38b535bf","977":"cbb0da78"}[chunkId] + ".chunk.js";
};